import(/* webpackMode: "eager" */ "/vercel/path0/app/mypage/page.tsx");
